/**
 * 模块: 统一配置管理页面
 * 职责: 集成权重配置、FBA费率和AI偏好配置的统一入口
 * 限制: <150行
 */

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Layout, Button, Spin, Tag } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { AIConfigPanel } from '../../components/SKUDetail/AIConfigPanel';
import { useConfigData } from './hooks/useConfigData';
import { ConfigSidebar } from './components/ConfigSidebar';
import { ConfigContent } from './components/ConfigContent';
import './ConfigManager.css';

const { Content } = Layout;

export const ConfigManagerPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isStandalone = !id;

  // 状态管理
  const [selectedKey, setSelectedKey] = useState<string>('market_opportunity');
  const [openKeys, setOpenKeys] = useState<string[]>(['scoring', 'logistics', 'system']);

  // 数据Hook
  const {
    loading,
    presets,
    currentConfig,
    skuName,
    updateConfig,
    applyPresetToMetric
  } = useConfigData(id);

  return (
    <Layout className="config-manager-page" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      {/* 顶部导航栏 */}
      <div className="page-header" style={{ background: '#fff', padding: '16px 24px', borderBottom: '1px solid #f0f0f0' }}>
        <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {!isStandalone && (
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(`/analysis/${id}`)}>
              返回
            </Button>
          )}
          <h1 style={{ margin: 0, fontSize: 20 }}>配置管理中心</h1>
          {skuName && <Tag color="blue">{skuName}</Tag>}
        </div>
      </div>

      <Layout>
        <ConfigSidebar
          selectedKey={selectedKey}
          onSelect={setSelectedKey}
          openKeys={openKeys}
          onOpenChange={setOpenKeys}
        />

        <Content style={{ padding: 24, overflowY: 'auto', height: 'calc(100vh - 64px)' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '100px 0' }}>
              <Spin size="large" tip="加载配置中..." />
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 24 }}>
              <div style={{ flex: 1 }}>
                <ConfigContent
                  selectedKey={selectedKey}
                  currentConfig={currentConfig}
                  presets={presets}
                  isStandalone={isStandalone}
                  onConfigChange={updateConfig}
                  onApplyPreset={applyPresetToMetric}
                />
              </div>

              {/* 右侧边栏：AI配置（仅在SKU模式下显示） */}
              {!isStandalone && id && (
                <div style={{ width: 350 }}>
                  <AIConfigPanel
                    skuId={parseInt(id)}
                    skuName={skuName || `SKU #${id}`}
                    onConfigChange={(config) => {
                      console.log('AI配置已更新:', config);
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};
